export const themes = {
    masculino: {
      bgPrimary: "#07111f",
      bgSecondary: "#050b14",
      highlight: "#ffbf1f",
      textColor: "#ffffff",
      subTextColor: "rgba(255,255,255,0.88)",
      metaTextColor: "#ffffff",
      buttonGreen: "#22c55e",
      buttonBlue: "#1692df",
      statusDot: "#22c55e",
      borderColor: "rgba(255,255,255,0.08)",
      glowColor: "rgba(255, 191, 31, 0.22)",
    },
  
    feminino: {
      bgPrimary: "#1a1020",
      bgSecondary: "#0d0712",
      highlight: "#ff4fa3",
      textColor: "#ffffff",
      subTextColor: "rgba(255,255,255,0.88)",
      metaTextColor: "#ffffff",
      buttonGreen: "#22c55e",
      buttonBlue: "#1692df",
      statusDot: "#22c55e",
      borderColor: "rgba(255,255,255,0.08)",
      glowColor: "rgba(255, 79, 163, 0.22)",
    },
  
    geral: {
      bgPrimary: "#0b0b0b",
      bgSecondary: "#000000",
      highlight: "#ffbf1f",
      textColor: "#ffffff",
      subTextColor: "rgba(255,255,255,0.88)",
      metaTextColor: "#ffffff",
      buttonGreen: "#22c55e",
      buttonBlue: "#1692df",
      statusDot: "#22c55e",
      borderColor: "rgba(255,255,255,0.08)",
      glowColor: "rgba(255, 191, 31, 0.18)",
    },
  };